import { Component, Injector, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { GenericBasicAggregateGUI } from "src/model/class/component classes/generic-basic-aggregate-gui";
import { SupervisionComponentAPI } from "src/model/class/component classes/supervision-component-api";
import { GuiComponent } from "src/model/enum/enumCustomInterface";

@Component({
    selector: "app-two-commands-one-label-template",
    templateUrl: "./two-commands-one-label-template.component.html",
    styleUrls: ["./two-commands-one-label-template.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TwoCommandsOneLabelTemplateComponent
  extends GenericBasicAggregateGUI
  implements OnInit
{
  public button1Component: SupervisionComponentAPI = null;
  public button2Component: SupervisionComponentAPI = null;
  public labelComponent: SupervisionComponentAPI = null;

  constructor(_injector: Injector) {
    super(_injector);
  }

  async ngOnInit() {
    for (let i = 0; i < this.aggregate.listComponent.length; i++) {
      const component = this.aggregate.listComponent[i];

      if (component.code === GuiComponent.COMMAND_BUTTON) {
        if (this.button1Component === null) {
          this.button1Component = component;
        } else {
          this.button2Component = component;
        }
      } else if (component.code === GuiComponent.LABEL) {
        this.labelComponent = component;
      }
    }
  }
}
